import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Alerts from './pages/Alerts';
import ProductSearch from './pages/ProductSearch';
import Resources from './pages/Resources';

// Placeholder pages for links not yet built
const News = () => <div className="p-20 text-center text-xl">News Archive Page (Coming Soon)</div>;
const About = () => <div className="p-20 text-center text-xl">About Us Page (Coming Soon)</div>;

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/products" element={<ProductSearch />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/news" element={<News />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

export default App;